"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var s = require("./Wallet.scss");
var PaymentMethodLayout_1 = require("./../PaymentMethodLayout");
var Translate_1 = require("./../Translate");
var Wallet = (function (_super) {
    __extends(Wallet, _super);
    function Wallet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Wallet.prototype.render = function () {
        var _a = this.props, paymentMethodName = _a.paymentMethodName, paymentMethodLabel = _a.paymentMethodLabel, payButtonLabel = _a.payButtonLabel;
        return (React.createElement(PaymentMethodLayout_1.default, { dataHook: "cashier-payments-method-wallet-" + paymentMethodName },
            React.createElement("div", { className: s.title },
                React.createElement(Translate_1.default, { forKey: "wallet.pay.with" }),
                React.createElement("span", null, "\u00A0"),
                React.createElement("span", null, paymentMethodLabel)),
            React.createElement("br", null),
            React.createElement("span", { className: s.content }, Translate_1.translate({
                forKey: 'payments.wallet.description',
                overrides: { paymentMethodLabel: paymentMethodLabel, payButtonLabel: Translate_1.translate({ forKey: payButtonLabel }) },
            }))));
    };
    Wallet.defaultProps = {
        payButtonLabel: 'button.pay.placeOrder',
    };
    return Wallet;
}(React.Component));
exports.default = Wallet;
//# sourceMappingURL=Wallet.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Wallet/Wallet.js
// module id = 216
// module chunks = 0 1